import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DTypeFormTextField } from '@grupo-constant/next-dtype/form';
import {
    CODEBARSCANNERWITHSELECT_URI, SELECTFROMURI_COLUMN_URI,
    SELECTWITHGIVENOPTIONS_COLUMN_URI
} from '@grupo-constant/next-dtype/types';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { FieldChiplistComponent } from '../../../components/field-chiplist/field-chiplist.component';

@Component({
    selector: 'complex-unique-index-field-component',
    templateUrl: './complex-unique-index-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FieldChiplistComponent]
})
export class DtypeComplexUniqueIndexFieldComponent implements DTypeFormFieldComponent {


    @Input() field: DTypeFormTextField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    validTypes = [
        SELECTFROMURI_COLUMN_URI,
        SELECTWITHGIVENOPTIONS_COLUMN_URI,
        CODEBARSCANNERWITHSELECT_URI
    ];

    constructor() { }
}
